import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  TableCell,
  TableRow,
  Box,
  Typography,
  Grid,
} from "@mui/material";
import { UseStatus } from "../../../../components/Status/hooks/useStatus";
import { ItemTemporality } from "../../../../model/ItemModel";
import WorkSpaceItemListFileComponentImage from "../../../WorkSpaceItem/WorkSpaceItemListFileComponentImage";
import { GenericTable } from "../../../AdminConsole/UsersAndGroups/components/GenericTable/GenericTable";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { shorten } from "../../../../utils/textHelpers";
import KeydriveDeadline from "../../../../components/KeydriveComponents/KeydriveDeadline";
import { getDueDateStatus } from "../../../../utils/setDate";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import FileDisabledIcon from "../../../../assets/icons/filesIcon/FileDisabledIcon";
import KeydriveTooltip from "../../../../components/KeydriveComponents/Tooltip/KeydriveTooltip";

interface TemporalityListCompProps {
  itemTemporalities: ItemTemporality[];
}

const GridArchive = React.forwardRef<HTMLTableRowElement, TemporalityListCompProps>(
  ({ itemTemporalities }, ref) => {
    const { t } = useTranslation();
    const lastIndex = itemTemporalities.length - 1;

    if (itemTemporalities.length <= 0) {
      return (
        <Grid container direction="column" alignItems="center" height="calc(100vh - 340px)" justifyContent="center" sx={{ padding: "40px 0" }} gap={2}>
          <FileDisabledIcon />
          
          <KeyDriveBodyMax 
            text="Não há Temporalidade"
            color="#2d2d2d"
            needBold={true}
            needEllipses={false}
          />

          <KeyDriveBodyMin 
            text="Parece que nenhuma temporalidade foi adicionada ainda. Para adicionar uma nova, acesse a lista de Documentos."
            color="#818181"
            needBold={false}
            needEllipses={false}
          />
        </Grid>
      )
    }

    return (
      <GenericTable
        distributeColumns
        headers={[
          t("Temporality.Name"),
          "Status",
          t("Temporality.Deadline"),
          t("Temporality.DeadlineStatus"),
        ]}
        bodyData={
          itemTemporalities.map((itemTemporality, index) => {
            const rawDate = itemTemporality.itemTemporality?.itemTemporality;
            const dataTemporality = rawDate
              ? moment(rawDate).format("DD/MM/YYYY")
              : "—";
            const dueDateStatus = rawDate
              ? getDueDateStatus(new Date(rawDate))
              : null;

            return (
              <TableRow
                key={itemTemporality.itemId}
                ref={index === lastIndex ? ref : null}
              >
                <TableCell />
                <TableCell>
                  <KeydriveTooltip
                    title={`${itemTemporality?.name ?? "N/A"}`}
                    start
                  >                      
                    <Box sx={{ display: "flex"}}>
                      <Box marginRight="8px">
                        <WorkSpaceItemListFileComponentImage
                          extension={itemTemporality?.extencion}
                          isFolder={false}
                          widthIcon="14px"
                        />
                      </Box>
                        <KeyDriveBodyMin
                          text={shorten(itemTemporality.name ?? "")}
                          color="#2b2b2b"
                          needBold={false}
                          needEllipses={false}
                        />
                    </Box>
                  </KeydriveTooltip>
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  <Typography variant="body2" component="span">
                    {UseStatus(
                      itemTemporality.isRelease,
                      itemTemporality.validationRule!,
                      itemTemporality.itemType!,
                      false,
                      itemTemporality.archiving,
                      itemTemporality.expired,
                      itemTemporality.d4Signed,
                      t
                    )}
                  </Typography>
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  <Typography variant="body2">{dataTemporality}</Typography>
                </TableCell>
                <TableCell sx={{ textAlign: "end" }}>
                  {dueDateStatus !== null && (
                    <KeydriveDeadline status={dueDateStatus} />
                  )}
                </TableCell>
              </TableRow>
            );
          })
        }
      />
    );
  }
);

export default GridArchive;